/* Mobile Menu + Language Selector — Vanilla JS */
(function() {
  /* ===== MOBILE MENU ===== */
  var hamburger = document.getElementById('ng-hamburger');
  var mobileMenu = document.getElementById('ng-mobile-menu');
  var mobileClose = document.getElementById('ng-mobile-menu-close');
  var mobileBackdrop = document.getElementById('ng-mobile-menu-backdrop');

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function() {
      mobileMenu.classList.add('active');
      document.body.style.overflow = 'hidden';
    });

    function closeMobile() {
      mobileMenu.classList.remove('active');
      document.body.style.overflow = '';
    }

    if (mobileClose) mobileClose.addEventListener('click', closeMobile);
    if (mobileBackdrop) mobileBackdrop.addEventListener('click', closeMobile);

    // Accordion sub-menus
    document.querySelectorAll('.ng-mobile-menu__toggle').forEach(function(toggle) {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        var parent = this.closest('.ng-mobile-menu__item');
        parent.classList.toggle('open');
      });
    });
  }

  /* Language selector removed — no translations available yet */
})();
